exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.jst-erp-scene[data-v-4ff6ff64] {\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  color: #303133;\n  text-align: left;\n  background: #fff;\n}\n[data-v-4ff6ff64] .step-player {\n  display: block;\n  width: 100%;\n}\n[data-v-4ff6ff64] .step-player .stage {\n  width: 100%;\n  min-height: 420px;\n  overflow: hidden;\n  background-color: #eef2f7;\n}\n[data-v-4ff6ff64] .step-player .hotspot {\n  z-index: 3;\n}\n[data-v-4ff6ff64] .step-player .field {\n  z-index: 4;\n  border-radius: 2px;\n}\n[data-v-4ff6ff64] .step-player .field-input {\n  color: #303133;\n  background: rgba(255, 255, 255, 0.01);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4ff6ff64","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/simulate/jushuitan/JstErpOrderQueryScene.vue
// module id = 1375
// module chunks = 0